module.exports = __webpack_public_path__ + "img/hand-peace.88b24974.svg";